<template>
	<div :class="['map-nav', { 'directory-open' : this.directoryOpen }]">
		<ul>
			<li ref="building-map-btn" role="button" v-on:click="onBuildingMap" :class="[{ 'active': this.currentMap === 'main' }]">
				{{ buildingBtnName }}
			</li>
			<li ref="garden-map-btn" role="button" v-on:click="onGardensMap" :class="[{ 'active': this.currentMap === 'gardens' }]">
				{{ gardensBtnName }}
			</li>
		</ul>
	</div>
</template>

<script>
	import localizationData from '../data/LocalizedStrings.json';

	export default {
		name: "MapNav",
		data: function() {
			return {
				sharedStore: window.store,
				buildingBtnName: "Building Map",
				gardensBtnName: "Gardens Map",
				directoryBtnName: "Directory"
			}
		},
		mounted: function() {

		},
		computed: {
			currentMap: function() {
				return this.sharedStore.state.currentMap;
			},
			directoryOpen: function() {
				return this.sharedStore.state.directoryOpen;
			}
		},
		watch: {
			"sharedStore.state.languageCode": function() {
				this.updateButtonNames();
			}
		},
		methods: {
			setCurrentMap: function(mapName) {
				this.sharedStore.setDirectoryMap(mapName);
				this.sharedStore.setCurrentMap(mapName);
			},
			updateButtonNames: function() {
				let languageCode = this.sharedStore.state.languageCode;

				this.buildingBtnName = localizationData.buildingMap[languageCode];
				this.gardensBtnName = localizationData.gardensMap[languageCode];
				this.directoryBtnName = localizationData.directory[languageCode];
			},
			onBuildingMap: function() {
				this.sharedStore.setDirectoryOpen(false);
				this.setCurrentMap('main');
			},
			onGardensMap: function() {
				this.sharedStore.setDirectoryOpen(false);
				this.setCurrentMap('gardens');
			}
		}
	};
</script>

<style scoped lang="scss">
	.map-nav {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: rgb(25, 25, 25);
		color: #ffffff;

    &.directory-open {
      z-index: 1;
    }
    

		@media (min-aspect-ratio: 1/1) {
			display: none;
		}
	}

	ul {
		margin: 0;
		padding: 2px 0;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	li {
		padding: 12px 0;
		flex-grow: 1;
		font-weight: bold;
		font-size: 1rem;
		cursor: pointer;
		transition: 0.2s;

		border-right: 2px solid rgb(65, 65, 65);

		&:last-child {
			border-right: none;
		}

		&.active {
			color: black;
			background: white;
		}

		.kiosk & {
			font-size: 2rem;
		}
	}

	.directory-btn {
		&:active {
			color: black;
			background: white;
			transition: 0s;
		}
	}
</style>
